import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-order-status-langs',
  templateUrl: './order-status-langs.component.html',
  styleUrls: ['./order-status-langs.component.css']
})
export class OrderStatusLangsComponent implements OnInit {
    orderStatusId;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.orderStatusId = this.stateService.getStateParams()['orderstatus_id'];
    }

    private async loadLanguages(): Promise<void> {
        if (!!this.orderStatusId) {
            this.inputListLanguages = await this.datatask.Post(2514, { orderstatus_id: this.orderStatusId });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(2515, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    orderstatus_id: number;
    orderstatuslang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderStatusLangs', {
//        templateUrl: 'views/components/views/orderStatusLangs/orderStatusLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'orderStatusLangsService', function ($stateParams, stateService, orderStatusLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let orderStatusId = $stateParams.orderstatus_id;

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await orderStatusLangsService.listOrderStatusLanguages({ orderstatus_id: orderStatusId });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                orderStatusLangsService.saveObj({ records: vm.model.inputListLanguages }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
